import { render } from "./MyPaymentsView.vue?vue&type=template&id=cdcb1394&scoped=true"
import script from "./MyPaymentsView.vue?vue&type=script&lang=js"
export * from "./MyPaymentsView.vue?vue&type=script&lang=js"

import "./MyPaymentsView.vue?vue&type=style&index=0&id=cdcb1394&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cdcb1394"]])

export default __exports__